import React from 'react';
import cn from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import InfoIcon from 'swag-client-common/components/icons/info-icon';
import classes from './setupfee-tooltip.scss';
const defaultTooltipText = 'In the future, when you reorder this product with the same print, your setup fee will be free.';
const additionalText = 'This is a shared setup fee. You only pay a one-time set up fee for each product, no matter how many boxes you add it to.';
const setupFeeTooltipStyles = {
  popper: classes.setupFeeTooltipPopper,
  tooltip: classes.tooltipRoot
};
function getTooltipText({
  isBoxItem,
  isSharedOrRelatedItem
}) {
  switch (true) {
    case isBoxItem && isSharedOrRelatedItem:
      {
        return `${additionalText}`;
      }
    case isSharedOrRelatedItem:
      {
        return `${defaultTooltipText} ${additionalText}`;
      }
    default:
      {
        return defaultTooltipText;
      }
  }
}
const SetupFeeTooltip = ({
  isSharedOrRelatedItem = false,
  isBoxItem = false,
  infoWrapperClassName = '',
  infoButtonClassName = '',
  placement,
  isLimitedEdition
}) => {
  return /*#__PURE__*/React.createElement(Tooltip, {
    title: getTooltipText({
      isBoxItem,
      isSharedOrRelatedItem
    }),
    placement: placement || Placement.RIGHT,
    mode: "light",
    className: infoWrapperClassName,
    classes: setupFeeTooltipStyles
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: cn(classes.infoButton, infoButtonClassName),
    isLimitedEdition: isLimitedEdition
  }));
};
export default SetupFeeTooltip;